export default "__VITE_ASSET__BJ1oS9Tp__"